import { MouseEvent } from "react";

import { useFilterHandlers } from "@/components/filter/useFilterHandlers";

import styles from "./SecondaryFilterBtn.module.scss";

interface SecondaryFilterBtnProps {
  openFilter(): void;
}

const SecondaryFilterBtn = ({ openFilter }: SecondaryFilterBtnProps) => {
  const {
    applyCategories,
    applyCollections,
    selectedFilters,
    checkSecondaryFiltersApplied,
  } = useFilterHandlers();

  const onClick = (e: MouseEvent) => {
    e.preventDefault();
    openFilter();
  };

  const onResetClick = (e: MouseEvent) => {
    e.stopPropagation();
    if (selectedFilters.categories?.length) {
      applyCategories(selectedFilters.categories);
    } else if (selectedFilters.collections?.length) {
      applyCollections(selectedFilters.collections);
    } else {
      /*
       * @TODO: Сейчас не регалментировано поведение фильтра без выбранной категории или коллекции
       *   но такое бывает (при клике на баннер и включении 1+1=3, например)
       */
      window.location.href = "/";
    }
  };

  const secondaryFiltersApplied = checkSecondaryFiltersApplied();

  return (
    <button className={styles.button} onClick={onClick}>
      ФИЛЬТР
      {secondaryFiltersApplied && (
        <>
          <span className={styles.reset} onClick={onResetClick}>
            <img src="/static/img/icons-v6/cross.svg" alt="сбросить фильтр" />
          </span>
          <span className={styles.resetClickArea} onClick={onResetClick} />
        </>
      )}
    </button>
  );
};

export default SecondaryFilterBtn;
